import React from "react";
import { useLocation, useNavigate } from "react-router";
import { LiveboardCategory } from "../types";
import { useLiveboardsStore } from "../store";

export function useLiveboardSelection(liveboardCategories: LiveboardCategory[] = []) {
  const navigate = useNavigate();
  const location = useLocation();

  const selectedLiveboardId = useLiveboardsStore((state) => state.selectedLiveboardId);
  const setSelectedLiveboardId = useLiveboardsStore((state) => state.setSelectedLiveboardId);

  const liveboardIdFromUrl =
    location.pathname.match(/\/(pinboard|schedules)\/([^/]+)/)?.[2] || null;

  React.useEffect(() => {
    if (!liveboardIdFromUrl) {
      if (!selectedLiveboardId) {
        if (liveboardCategories.length > 0) {
          const firstCategory = liveboardCategories[0];
          if (firstCategory.liveboards.length > 0) {
            const firstLiveboard = firstCategory.liveboards[0];
            setSelectedLiveboardId(firstLiveboard.id);
          }
        }
        return;
      } else {
        navigate(`/pinboard/${selectedLiveboardId}`, { replace: true });
      }
    } else {
      setSelectedLiveboardId(liveboardIdFromUrl);
    }
  }, [
    liveboardIdFromUrl,
    selectedLiveboardId,
    liveboardCategories,
    navigate,
    setSelectedLiveboardId,
  ]);

  return {
    selectedLiveboardId,
  };
}
